import { render } from "./ElementSetting.vue?vue&type=template&id=6215259b"
import script from "./ElementSetting.vue?vue&type=script&lang=js"
export * from "./ElementSetting.vue?vue&type=script&lang=js"

import "./ElementSetting.vue?vue&type=style&index=0&id=6215259b&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__